import { Injectable } from '@angular/core';
import { Observable, Subject, asapScheduler } from 'rxjs';
import { observeOn } from 'rxjs/operators';

export enum AlertType {
  Info,
  Warning,
  Success,
  Error,
}

export interface AlertInfo {
  type: AlertType;
  title: string;
  message: string;
  closeable: boolean;
  targetId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private readonly alertSubject = new Subject<AlertInfo | null>();
  readonly alert$: Observable<AlertInfo | null> = this.alertSubject
    .asObservable()
    .pipe(observeOn(asapScheduler));

  constructor() {}

  setAlert(alert: AlertInfo) {
    this.alertSubject.next(alert);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  }

  clearAlert(): void {
    this.alertSubject.next(null);
  }
}
